/** Boost contrast / scale for Tesseract on label photos. */
export function preprocessImeiLabelDataUrl(dataUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const maxSide = Math.max(img.width, img.height)
      const scale = maxSide < 900 ? 2 : maxSide > 1600 ? 1 : 1.5
      const w = Math.round(img.width * scale)
      const h = Math.round(img.height * scale)
      const canvas = document.createElement('canvas')
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        resolve(dataUrl)
        return
      }
      ctx.drawImage(img, 0, 0, w, h)
      const imageData = ctx.getImageData(0, 0, w, h)
      const { data } = imageData
      for (let i = 0; i < data.length; i += 4) {
        const gray = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]
        const v = gray > 165 ? 255 : gray < 95 ? 0 : gray > 128 ? 255 : 0
        data[i] = v
        data[i + 1] = v
        data[i + 2] = v
      }
      ctx.putImageData(imageData, 0, 0)
      resolve(canvas.toDataURL('image/jpeg', 0.92))
    }
    img.onerror = () => reject(new Error('image load failed'))
    img.src = dataUrl
  })
}
